import { API_CONFIG } from '../config/api';

interface ApiKey {
  id: number;
  name: string;
  api_key_suffix: string;
  created_date: string;
}

interface ApiKeyListResponse {
  content: ApiKey[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

interface CreateApiKeyResponse {
  id: number;
  name: string;
  api_key: string; // API Key completa retornada apenas na criação
  created_date: string;
}

interface UpdateApiKeyRequest {
  name: string;
}

const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
});

export const apiKeyService = {
  async listApiKeys(page: number = 1, perPage: number = 10): Promise<ApiKeyListResponse> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.API_KEYS}?page=${page}&per_page=${perPage}`,
        {
          headers: getHeaders(),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch API keys');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async createApiKey(name: string): Promise<CreateApiKeyResponse> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.API_KEYS}`,
        {
          method: 'POST',
          headers: getHeaders(),
          body: JSON.stringify({ name }),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to create API key');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async deleteApiKey(id: number): Promise<void> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.API_KEYS}/${id}`,
        {
          method: 'DELETE',
          headers: getHeaders(),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to delete API key');
      }
    } catch (error) {
      throw error;
    }
  },

  async updateApiKey(id: number, data: UpdateApiKeyRequest): Promise<void> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.API_KEYS}/${id}`,
        {
          method: 'PATCH',
          headers: getHeaders(),
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to update API key');
      }
    } catch (error) {
      throw error;
    }
  },
}; 